import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=b1dee9b2&scoped=true"
import script from "./CustomerSettings.vue?vue&type=script&lang=ts"
export * from "./CustomerSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dee9b2",
  null
  
)

export default component.exports